import { Route, Routes } from "react-router-dom"
import ChinaLayout from "./ChinaLayout"
import { lazy, Suspense } from "react"
import ScrollToTop from "../Routerpage/ScrollToTop"

const LandingChinese = lazy(()=> import("./landingChinese/LandingChinese"))
const PageNotFound = lazy(()=> import("../404page/PageNotFound"))

export default function ChinaRoutes() {
  return (
    <>
    <Suspense fallback={
          <>
            <div className="loader-only-css">
              <div className="loader-inner-css">
                <div></div>
              </div>
            </div>
          </>
          }>
            <ScrollToTop />
            <Routes>
              <Route path="/zh-tw" element={<ChinaLayout />}>
                <Route index element={<LandingChinese />} />
                <Route path= '*' element={< PageNotFound/>} />
              </Route>              
            </Routes>
          </Suspense>
      
    </>
  )
}
